export default __webpack_public_path__ + "static/media/INSEE-Plus-esg-Web.f7cfbb8c.gif";